class AsthetikaMediaGallery extends HTMLElement {
  constructor() {
    super();
    this.slides = this.querySelectorAll(".ast-media-gallery__slide");
    this.thumbs = this.querySelectorAll(".ast-media-gallery__thumb");
    this.prevBtn = this.querySelector(".ast-media-gallery__btn--prev");
    this.nextBtn = this.querySelector(".ast-media-gallery__btn--next");
    this.zoomBtn = this.querySelector(".ast-media-gallery__btn--zoom");

    this.modal = this.querySelector(".ast-media-modal");
    this.modalSlides = this.querySelectorAll(".ast-media-modal__slide");
    this.modalPrev = this.querySelector(".ast-media-modal__btn--prev");
    this.modalNext = this.querySelector(".ast-media-modal__btn--next");
    this.modalClose = this.querySelector(".ast-media-modal__btn--close");
    this.counterCurrent = this.querySelector(".ast-media-modal__counter-current");

    this.currentIndex = 0;
    this.totalSlides = this.slides.length;
    this.isAnimating = false;

    if (this.totalSlides > 0) this.initEvents();
  }

  initEvents() {
    this.thumbs.forEach((thumb) => {
      thumb.addEventListener("click", (e) => {
        if (this.isAnimating) return;
        this.goToSlide(parseInt(e.currentTarget.dataset.index, 10));
      });
    });

    if (this.prevBtn) {
      this.prevBtn.addEventListener("click", (e) => { e.stopPropagation(); if (!this.isAnimating) this.goToPrev(); });
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener("click", (e) => { e.stopPropagation(); if (!this.isAnimating) this.goToNext(); });
    }

    if (this.modal) {
      if (this.zoomBtn) {
        this.zoomBtn.addEventListener("click", (e) => { e.stopPropagation(); this.openModal(); });
      }

      this.slides.forEach((slide) => slide.addEventListener("click", () => this.openModal()));

      if (this.modalClose) this.modalClose.addEventListener("click", () => this.closeModal());

      if (this.modalPrev) {
        this.modalPrev.addEventListener("click", (e) => { e.stopPropagation(); if (!this.isAnimating) this.goToPrev(); });
      }
      if (this.modalNext) {
        this.modalNext.addEventListener("click", (e) => { e.stopPropagation(); if (!this.isAnimating) this.goToNext(); });
      }

      this.modal.addEventListener("click", (e) => {
        if (e.target === this.modal) this.closeModal();
      });

      document.addEventListener("keydown", (e) => {
        if (!this.modal.classList.contains("ast-media-modal--open")) return;
        if (e.key === "Escape") this.closeModal();
        if (e.key === "ArrowLeft") this.goToPrev();
        if (e.key === "ArrowRight") this.goToNext();
      });

      this._initZoom();
    }
  }

  _initZoom() {
    this.modalSlides.forEach((slide) => {
      const wrap = slide.querySelector(".ast-media-modal__zoom-wrap");
      const img = slide.querySelector(".ast-media-modal__img");
      if (!wrap || !img) return;

      let zoomed = false;

      wrap.addEventListener("click", (e) => {
        if (zoomed) {
          zoomed = false;
          wrap.classList.remove("is-zoomed");
          img.style.removeProperty("--zoom-x");
          img.style.removeProperty("--zoom-y");
        } else {
          const rect = wrap.getBoundingClientRect();
          const x = ((e.clientX - rect.left) / rect.width) * 100;
          const y = ((e.clientY - rect.top) / rect.height) * 100;
          img.style.setProperty("--zoom-x", `${x}%`);
          img.style.setProperty("--zoom-y", `${y}%`);
          zoomed = true;
          wrap.classList.add("is-zoomed");
        }
      });

      wrap.addEventListener("mousemove", (e) => {
        if (!zoomed) return;
        const rect = wrap.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;
        wrap.classList.add("is-panning");
        img.style.setProperty("--zoom-x", `${x}%`);
        img.style.setProperty("--zoom-y", `${y}%`);
      });

      wrap.addEventListener("mouseleave", () => {
        wrap.classList.remove("is-panning");
      });
    });
  }

  _resetZoom() {
    this.modalSlides.forEach((slide) => {
      const wrap = slide.querySelector(".ast-media-modal__zoom-wrap");
      const img = slide.querySelector(".ast-media-modal__img");
      if (!wrap || !img) return;
      wrap.classList.remove("is-zoomed", "is-panning");
      img.style.removeProperty("--zoom-x");
      img.style.removeProperty("--zoom-y");
    });
  }

  openModal() {
    this.modal.classList.add("ast-media-modal--open");
    document.body.style.overflow = "hidden";
  }

  closeModal() {
    this.modal.classList.remove("ast-media-modal--open");
    document.body.style.overflow = "";
    this._resetZoom();
  }

  goToPrev() {
    this.goToSlide(this.currentIndex === 0 ? this.totalSlides - 1 : this.currentIndex - 1);
  }

  goToNext() {
    this.goToSlide(this.currentIndex === this.totalSlides - 1 ? 0 : this.currentIndex + 1);
  }

  goToSlide(index) {
    if (index === this.currentIndex) return;
    this.isAnimating = true;

    this.thumbs[this.currentIndex].classList.remove("ast-media-gallery__thumb--active");
    this.thumbs[this.currentIndex].setAttribute("aria-selected", "false");
    this.thumbs[index].classList.add("ast-media-gallery__thumb--active");
    this.thumbs[index].setAttribute("aria-selected", "true");
    this.thumbs[index].scrollIntoView({ behavior: "smooth", block: "nearest", inline: "nearest" });

    this.slides[this.currentIndex].classList.remove("ast-media-gallery__slide--active");
    this.slides[index].classList.add("ast-media-gallery__slide--active");

    if (this.modalSlides.length > 0) {
      this._resetZoom();
      this.modalSlides[this.currentIndex].classList.remove("ast-media-modal__slide--active");
      this.modalSlides[index].classList.add("ast-media-modal__slide--active");
    }

    if (this.counterCurrent) this.counterCurrent.textContent = index + 1;

    this.currentIndex = index;
    setTimeout(() => { this.isAnimating = false; }, 400);
  }
}

if (!customElements.get("asthetika-media-gallery")) {
  customElements.define("asthetika-media-gallery", AsthetikaMediaGallery);
}